/*
 * Fix facet link colours
 *
 * Shopify’s Dawn theme applies default link colours to various
 * underlined link classes used in the filtering UI. Our previous
 * attempts to override these via CSS and inline styles were still
 * overridden in some contexts (especially on dynamic filter re-renders).
 * This script explicitly sets the colour of the “Remove all”, “Reset”,
 * and mobile “Clear” links to red on page load and whenever the
 * faceting UI refreshes. Using JavaScript ensures the style is
 * consistently applied after AJAX filter updates.
 */

document.addEventListener('DOMContentLoaded', function () {
  function applyRedColour() {
    var selectors = [
      '.facets__reset.link.underlined-link',
      '.active-facets__button-remove.underlined-link',
      '.mobile-facets__clear.underlined-link'
    ];
    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        el.style.setProperty('color', '#ff0000', 'important');
        // Also color any text nodes wrapped in spans
        el.querySelectorAll('span').forEach(function (span) {
          span.style.setProperty('color', '#ff0000', 'important');
        });
      });
    });
  }
  // Apply colours once on initial load
  applyRedColour();
  // Reapply after faceting UI updates (Shopify emits these events on filter change and section reload)
  document.addEventListener('facets:updated', applyRedColour);
  document.addEventListener('shopify:section:load', applyRedColour);
});